import { useCallback } from "react";

const truncateDecimals = (valStr, decimals) => {
  const parts = valStr.split(".");
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, decimals);
    return parts.join(".");
  }
  return valStr;
};

export const useHandleNumberInputOnChangeV2 = (setInputValues) => {
  return useCallback((e, props = {}) => {
    const { name, value, selectionStart } = e.target;

    let raw = value
      .replace(/[^\d.-]/g, "")
      .replace(/(\..*)\./g, "$1");

    const hasNegative = props.allowNegative && raw.includes("-");
    raw = raw.replace(/-/g, "");
    if (hasNegative) {
      raw = "-" + raw;
    }

    if (props.decimals === 0) {
      raw = raw.split(".")[0];
    }

    let [intPart = "", decimalPart = ""] = raw.split(".");

    // Enforce maxDigits limit (counts only digits in integer part)
    if (props.maxDigits != null) {
      const intDigits = intPart.replace(/[^0-9]/g, "");
      if (intDigits.length > props.maxDigits) {
        return; // reject input exceeding max digits
      }
    }

    const isAddingDecimal = value.endsWith(".") && selectionStart === value.length;

    if (!raw || raw === "-") {
      raw = "0";
      intPart = "0";
      decimalPart = "";
    }

    if (raw === ".") {
      setInputValues((prev) => ({
        ...prev,
        [name]: "0.",
        [`${name}_`]: "0.",
      }));
      requestAnimationFrame(() => {
        const input = document.querySelector(`input[name="${name}"]`);
        if (input) input.setSelectionRange(2, 2);
      });
      return;
    }

    let formattedValue = raw;
    const shouldFormat = !isAddingDecimal && !raw.endsWith(".");

    if (shouldFormat && intPart) {
      const numericValue = parseInt(intPart.replace(/,/g, ""), 10);

      const safeNumeric = isNaN(numericValue) ? 0 : numericValue;
      const formattedInt = safeNumeric.toLocaleString("en-US");

      formattedValue = hasNegative ? `-${formattedInt}` : formattedInt;

      if (decimalPart) {
        formattedValue += `.${decimalPart}`;
      } else if (raw.includes(".")) {
        formattedValue += ".";
      }
    }

    if (props.decimals != null && decimalPart) {
      raw = truncateDecimals(raw, props.decimals);
      formattedValue = truncateDecimals(formattedValue, props.decimals);
    }

    const diff = formattedValue.length - value.length;
    let newCursor = Math.max(0, (selectionStart || 0) + diff);

    // When adding a decimal point, position cursor after the dot
    if (isAddingDecimal) {
      newCursor = formattedValue.length;
    }

    setInputValues((prev) => ({
      ...prev,
      [name]: raw,
      [`${name}_`]: formattedValue,
    }));

    requestAnimationFrame(() => {
      const input = document.querySelector(`input[name="${name}"]`);
      if (input) {
        if (isAddingDecimal && !input.value.includes(".")) {
          input.value = input.value + ".";
        }
        input.setSelectionRange(newCursor, newCursor);
      }
    });
  }, [setInputValues]);
};
